export default "__VITE_ASSET__fIdh2w8_0vgPq1hdHJ0xhw__"